import { render } from "./Diskaun.vue?vue&type=template&id=0a5a3074"
import script from "./Diskaun.vue?vue&type=script&lang=js"
export * from "./Diskaun.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__